// eslint-disable-next-line import/prefer-default-export
export const MAJ_PRIX_UNITAIRE = {
  actionLibelle: 'Modifier prix unitaire',
  title: 'Modification du prix unitaire',
  message: 'Action sur le prix unitaire',
  problemAddOccurred: 'L\'ajout est impossible. Les champs suivants sont obligatoires : ',
  actions: {
    cancel: 'Annuler',
    validate: 'Appliquer',
  },
  error: {
    title: 'Modification interdite',
    pourcentage: 'Le pourcentage doit être compris entre 0 et 100',
  },
  types: {
    majoration: 'Majoration',
    reduction: 'Réduction',
    remplacement: 'Remplacer par',
  },
};
